const hj = window.hj;

export default function getHotjarUserID() {
  var hjUID = '';
  try {
    if (
      typeof window !== 'undefined' &&
      window.hasOwnProperty('hj') &&
      window.hj.hasOwnProperty('globals')
    ) {
      hjUID = window.hj.globals.get('userId');
    }
  } catch (err) {
    /** ignore **/
  }
  return hjUID && hjUID !== '' ? hjUID.split('-').shift() : '';
}
